import { trackInternalEvent } from '@rio/tracking'
import Button, { ButtonTheme } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { Body, Container, CrownIcon, HeaderContainer, Subtitle, Title } from './style'

const TRANSLATION_KEY = 'builder.interview_prep_view.question_library.premium_banner'

export const PremiumBanner = () => {
  const { i18n } = useI18n()

  return (
    <Container>
      <Body>
        <HeaderContainer>
          <CrownIcon />
          <Title>{i18n.t(`${TRANSLATION_KEY}.title`)}</Title>
        </HeaderContainer>

        <Subtitle>{i18n.t(`${TRANSLATION_KEY}.subtitle`)}</Subtitle>
        <div>
          <Button
            theme={ButtonTheme.alternative}
            onClick={() => {
              trackInternalEvent('click_upgrade_paywall', {
                label: 'interview_prep',
                parameter: 'library',
              })
              goToBillingPlanPage({ referrerPage: 'interviewPrep' })
            }}
          >
            {i18n.t(`${TRANSLATION_KEY}.upgrade_now`)}
          </Button>
        </div>
      </Body>
    </Container>
  )
}
